<template>
  <div class="index-main-left">
    <component :is="item" v-for="(item, index) in conf" :key="index" :ref="item" class="box" />
  </div>
</template>
<script>
let components = {};
const conf = ['leftApp', 'etcEnter', 'leftFinancialCenter', 'leftChart'];
conf.forEach(item => (components[item] = require('./components/' + item + '.vue').default));

export default {
  components,
  data() {
    return {
      conf,
    };
  },
};
</script>

<style lang="scss" scoped>
.index-main-left {
  width: 100%;
  box-sizing: border-box;
  padding-right: 463px;
}
</style>
